module.exports = __webpack_public_path__ + "static/media/MemoryClick.4ef4f50e.png";